var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFormAutomation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H9V6H10V5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H6V6H7V5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H10.5V9H11C11.2651 8.9997 11.5193 8.89424 11.7068 8.70677C11.8942 8.5193 11.9997 8.26512 12 8V6H13V5H12V4C11.9997 3.73488 11.8942 3.4807 11.7068 3.29323C11.5193 3.10576 11.2651 3.0003 11 3H10V1H9V3H7V1H6V3H5C4.73488 3.0003 4.4807 3.10576 4.29323 3.29323C4.10576 3.4807 4.0003 3.73488 4 4V5H3V6H4V8C4.0003 8.26512 4.10576 8.5193 4.29323 8.70677C4.4807 8.89424 4.73488 8.9997 5 9H5.5V10H3C2.73488 10.0003 2.4807 10.1058 2.29323 10.2932C2.10576 10.4807 2.0003 10.7349 2 11V15H3V11H13V15H14V11C13.9997 10.7349 13.8942 10.4807 13.7068 10.2932C13.5193 10.1058 13.2651 10.0003 13 10ZM5 4H11V8H5V4ZM6.5 9H9.5V10H6.5V9Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFormAutomation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/form-automation.e08f108af2c4cd4292d6183ceb32eb0e.svg";